export default "__VITE_ASSET__15c61134__"